module.exports = __webpack_public_path__ + "img/system.484e67c9.png";